var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"outlined":"","small":""}},[_c('time',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"pe-1 grey--text",attrs:{"small":""}},[_vm._v("mdi-timer-outline")]),_c('p',{staticClass:"mb-0 grey--text text--darken-1"},[_vm._v(_vm._s(_vm.humanizedDueDate))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }